module.exports = __webpack_public_path__ + "img/BURST.d39d6728.svg";